var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("zcy-site-top", {
        on: {
          "login-status-change": _vm.onLoginchange,
          "env-success": _vm.onEnvloaded
        }
      }),
      _vm._v(" "),
      _c("zcy-header"),
      _vm._v(" "),
      _c("zcy-nav", {
        attrs: { "show-cate": false, "show-border": _vm.showBorder }
      }),
      _vm._v(" "),
      _vm._t("default", null, {
        envHref: _vm.envHref,
        currentUserIdentity: _vm.currentUserIdentity
      }),
      _vm._v(" "),
      _c("zcy-bottom"),
      _vm._v(" "),
      _c("zcy-copyright")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ecebbf8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecebbf8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout.vue
// module id = jR3D
// module chunks = 1 2 4 5 7 8 9